import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { constants } from '../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class ListingLeadsService {

  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      // 'access-token': environment.prospektr_sell_backend_access_token
    }),
  };

  CreateListingLeads(input: any): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.prospector_listing_leads;
    return this.http
      .post<any>(url, input, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  UpdateListingLeads(id: string, input: any): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.prospector_listing_leads + '/' + id;
    return this.http
      .patch<any>(url, input, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

   // Error handling
   errorHandl(error: { error: { message: string; }; status: any; message: any; }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
